// 处理兼容问题
import 'babel-polyfill';
import $ from 'jquery'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';

import promise from 'es6-promise';
// vue-fullpage 引入
import 'fullpage.js/vendors/scrolloverflow';
import VueFullPage from 'vue-fullpage.js/dist/vue-fullpage.js';

promise.polyfill();


Vue.config.productionTip = false;

Vue.use(ElementUI);

Vue.use(VueFullPage);

// router.beforeEach((to,from,next)=>{
// 	let tempId = sessionStorage.getItem("tempId");
// 	if(from.path == '/' || from.path == '/home' || to.path == '/news-detail' || to.path == '/notice-list' || from.path == '/news-detail' || from.path == '/notice-list' || from.path == '/fifth/news-detail' || from.path == '/fifth/notice-list'){
// 		next();
// 	}else{
// 		if(tempId == 1){
// 			router.push({ path: '/first' })
// 		}else if(tempId == 2){
// 			router.push({ path: '/second' })
// 		}else if(tempId == 3){
// 			router.push({ path: '/thirdly' })
// 		}
// 	}
// })
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js